import { housekeepingQueryKeys as e } from "./useHousekeepingQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { housekeepingApi as n } from "@maat/api-main";
//#region src/housekeeping/useHousekeepingAttentionQuery.ts
var r = (r) => t({
	queryKey: e.attention(r?.propertyId),
	queryFn: () => n.getAttention(r?.propertyId ? { property_id: r.propertyId } : {}),
	enabled: r?.enabled ?? !0,
	staleTime: 6e4
});
//#endregion
export { r as useHousekeepingAttentionQuery };
